export default {"src":"/assets/_next/static/media/hu.529fc18b.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};